export function getInitiative(state) {
  return state.initiative;
}
